module.exports = __webpack_public_path__ + "static/media/mobileScreenshot08.aae1abb5.jpg";